export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'left',
    width: 70,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: ' displayImage',
    align: 'center',
    fixed: 'left',
    width: 80,
    showHeaderOverflow: true,
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'displayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'displayNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 210,
    showHeaderOverflow: true,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_displayPlatform') || '渠道产品',
    field: 'displayPlatform',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'displayPlatform' },
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        size: 'mini',
        min: 0,
        max: 9999999999,
        step: 1,
        precision: 0,
        controls: false,
      },
    },
  },
  {
    title: that.$l('table_label_PreOrderQty') || '采购数量',
    field: 'purchaseQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        size: 'mini',
        min: 0,
        max: 9999999999,
        step: 1,
        precision: 0,
        controls: false,
      },
    },
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ctnQty') || '箱数',
    field: 'ctnQty',
    align: 'center',
    minWidth: 80,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_PreOrderPrice') || '采购单价',
    field: 'purchasePrice',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subAmount') || '采购金额',
    field: 'subAmount',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_operateName') || '运营人员',
    field: 'operateName',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_MOQ') || 'MOQ',
    field: 'ftyMoq',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        size: 'mini',
        min: 0,
        max: 9999999999,
        step: 1,
        precision: 0,
        controls: false,
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ftyLeadTime') || '生产周期（天）',
    field: 'ftyLeadTime',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        size: 'mini',
        min: 0,
        max: 9999999999,
        step: 1,
        precision: 0,
        controls: false,
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_expectDeliveryDate') || '预计交期',
    field: 'expectDeliveryDate',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElDatePicker',
      props: {
        type: 'date',
        'value-format': 'yyyy-MM-dd',
        style: 'width: 100%',
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_avgSevenDayQty') || '7日均销量',
    field: 'avgSevenDayQty',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    isTotalColumn: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        size: 'mini',
        min: 0,
        max: 9999999999,
        step: 1,
        precision: 0,
        controls: false,
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_lessThanMoq') || '下单数量小于MOQ原因',
    field: 'lessThanMoq',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 50,
        showWordLimit: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_remark') || '备注',
    field: 'remark',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 500,
        showWordLimit: true,
        size: 'mini',
      },
    },
  },
  {
    title: that.$l('table_label_shippedQty') || '已出货数量',
    field: 'shippedQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_invQty') || '剩余未出数量',
    field: 'invQty',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
